import React, { useEffect, useState } from 'react';
// react-intl v2 has no hooks — use the injectIntl HOC (matches AssociateFilter.tsx + the app's react-intl 2.9).
import { FormattedMessage, injectIntl, InjectedIntlProps } from 'react-intl';
import Text from '@amzn/meridian/text';
import { getCurrentFormattedTime } from './util';

export interface RefreshTimerProps {
  /**
   * Dependency signal that triggers a re-read of the current time — mirrors v1
   * `RefreshTimer` `deps`. Keyed off the roster data/viewModel so the timestamp updates
   * whenever the data refreshes.
   */
  deps?: ReadonlyArray<unknown>;
}

/**
 * RefreshTimer — shows the last data-refresh time using the current locale (React + Meridian,
 * ported from v1 util/RefreshTimer.js). Renders `Text` + the `common.data_last_updated` message
 * followed by the locale-formatted current date/time, refreshing when `deps` change.
 * Design-system continuity: same Meridian `Text` (type "b200") and same i18n id as v1.
 */
const RefreshTimer: React.FC<RefreshTimerProps & InjectedIntlProps> = ({ deps = [], intl }) => {
  const [latestRefreshTime, setRefreshTime] = useState<string>('');

  useEffect(() => {
    setRefreshTime(getCurrentFormattedTime(intl.locale));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return (
    <Text type="b200">
      <FormattedMessage id="common.data_last_updated" defaultMessage="Data last updated" />: {latestRefreshTime}
    </Text>
  );
};

export default injectIntl(RefreshTimer);
